import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Logs from './Logs.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/process-logs',
      name: 'Logs',
      components: {
        default: Logs,
        header: AppHeader
      },
      meta: {
        dontShowInMenu: true
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
